const activationCodeDeliveryOptionsTemplate = `<pwr-mfa></pwr-mfa>`;
export default activationCodeDeliveryOptionsTemplate;
